import { AudioCompanion } from '@blisspointmedia/bpm-types/dist/Creative';

export type AdServer = 'Flashtalking';

export interface FlashtalkingVendor {
  name: string;
  pretty_name: string;
  // Placement-type keys this vendor supports, e.g. 'pixel', 'video_vast', 'audio_vast', 'display'.
  placement_types: string[];
}

export interface TagData {
  adServer: AdServer;
  company: string;
  derivedID: string;
  network: string;
  description: string;
  platform: string;
  dsp: string | null;
  vendorOptions: string[];
  splitLength: boolean;
  hasOverride: boolean;
  hasPlacement: boolean;
  deviceMap?: Record<string, boolean>;
  osMap?: Record<string, boolean>;
  lengthMap?: Record<string, boolean>;
  additionalParams?: string[];
  vendor?: string;
  audioCompanionOptions?: Record<string, AudioCompanion>;
  flashtalking_vendors?: FlashtalkingVendor[];
  campaignID?: number;
  startDate?: string;
  endDate?: string;
  placementType?: '' | 'Audio' | 'Pixel' | 'VAST' | 'Display';
  transcodeVendor?: string;
  extraTrackingPixels?: string[];
  dimensions?: string;
  dimensionsMap?: Record<string, boolean>;
}

export interface StagedTagData extends TagData {
  device?: string;
  OS?: string;
  length?: string;
  additionalParam?: string;
  name: string;
  creativeAllocationMap?: Record<string, number>;
  clickthroughUrlMap?: Record<string, string>; // Used if there are several creative-level clickthrough URLs.
  clickthroughUrl?: string; // Used if there is just a single placement-level clickthrough URL.
  audioCompanionMap?: Record<string, AudioCompanion>;
}

// Shape of each entry the sendPlacementsToFlashtalking / sendCreativeRotationsToFlashtalking
// comet lambdas return, keyed by placement ID: either the placement that was sent, or that same
// placement plus an error message if the send failed.
export interface FlashtalkingCometPlacementResult {
  name: string;
  error?: string;
}

// FT rejects these characters in placement names; sendTagsToFlashTalking sends the sanitized name,
// so results coming back from FT must be matched against it, not the raw staged tag name.
export const sanitizeFlashtalkingPlacementName = (name: string): string =>
  name.replace(/</g, 'Under').replace(/>/g, 'Over').replace(/[,;]/g, '/');
